import { blueprints } from '../blueprints/blueprints-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { jobLogger } from './jobLogger-sidecar'

export function createTask_deconstructHull(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'deconstruct-hull', {})
}

export function forceDeconstructHull(i: number, j: number) {
  let ctx = scene.getContext()
  let t = tileMapShip.getTile(ctx.mapShip, i, j)
  if (t) {
    tilesShip.setFloor(t, null)
  }
}

export function runTask_deconstructHull(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'deconstruct-hull')
  let m = jobLogger.assertReserved(job)

  // Are we at the right spot?
  if (!distance.isAt(m.i, m.j, task.i, task.j)) {
    return jobLogger.failTask(job, task, 'wrong spot')
  }

  let blueprintHere = blueprints.findAtSpot(m.i, m.j, (c) => true)

  // Blueprint went missing
  if (!blueprintHere) {
    return jobLogger.failTask(job, task, 'lost blueprint')
  }

  blueprints.kill(blueprintHere)

  let ctx = scene.getContext()
  let t = tileMapShip.getTile(ctx.mapShip, m.i, m.j)

  if (!t || !t.dataFloor) {
    // Nothing to deconstruct!
    return jobLogger.failTask(job, task, 'no floor')
  }

  tilesShip.setFloor(t, null)

  let car = cargoes.create('steel')
  cargoes.moveToTile(car, ctx.mapShip, m.i, m.j)
  monsters.pickupCargo(m, car)

  jobLogger.succeedTask(job, task)
}
